import { render } from "./onhand.vue?vue&type=template&id=1be4db0d"
import script from "./onhand.vue?vue&type=script&lang=js"
export * from "./onhand.vue?vue&type=script&lang=js"

import "./onhand.vue?vue&type=style&index=0&id=1be4db0d&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__